module.exports = __webpack_public_path__ + "src/assets/img/szst_sd_01@2x.852740a7.png";